import { OrderOriginIds } from '@/config/constants'

export default {
  activeOrders: (state, getters, rootState, rootGetters) => {
    return (
      state.activeOrders ||
      JSON.parse(window.localStorage.getItem('activeOrders'))
    )
  },
  currentOrderOriginId: (state, getters, rootStage, rootGetters) => {
    if (!rootGetters['client/isLoggedIn']) {
      return OrderOriginIds.LANDING_UNAUTHORIZED
    }
    return OrderOriginIds.LANDING_AUTHORIZED
  },
  // Добавлен геттер для флага переключения драфта заказа DEV-16832
  isDraftOrderFlowEnabled: (state) => {
    return state.isDraftOrderFlowEnabled
  },
}
